import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'

const routes = [
	{
		path: '/',
		name: 'Index',
		redirect: '/index',
		children:[
		  {
			path: '/index',
			name: 'IndexPage',
			component: () => import('../views/index.vue'),
			meta: {
			  title:'人脸识别'
			}
		  },
		]
	},
	{
		path: '/takePictures',
		name: 'TakePictures',
		component: () => import('../views/takePictures.vue'),
		meta: {
			title:'人脸拍照'
		}
	}
]

const router = createRouter({
	// history: createWebHistory(process.env.BASE_URL),
	history: createWebHashHistory(),
  	routes
})

export default router